import axios from 'axios'
import qs from 'qs'
import _get from 'lodash.get'
import {
  studentLoginUrl
} from '../constants/constants'
const requestCache = new Map()
const apiServer = process.env.BUILD_TEST
  ? 'http://api.t.shijieu.cn/'
  : 'https://api.shijieu.cn/'

const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? apiServer : 'http://api.t.shijieu.cn/',
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
  },
})

instance.interceptors.request.use(
  function(param) {
    return param
  },
  function(error) {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  function({ data }) {
    if (data.code === 200) {
      return Promise.resolve(data)
    } else if (data.code === 401) {
      window.location.replace(studentLoginUrl)
      return Promise.reject(data)
    } else if (data.code === 302) {
      debugger
      let redirectUrl = _get(data, 'data.xauth_redirect')
      window.location.replace(redirectUrl)
    } else {
      alert(data.message)
      return Promise.reject(data)
    }
  },
  function(error) {
    alert('网络错误！错误码：' + error.response.status)
    return Promise.reject(error)
  }
)

const combineToken = (param) => {
  const token = localStorage.getItem('token')
  return {
    ...param,
    'xauth_ticket': token
  }
}

export const getSearch = () => {
  const queryStr = window.location.search.replace(/^\?/, '')
  return qs.parse(queryStr)
}

export const get = (url, param, useCache = false) => {
  if (useCache) {
    let key = `${url}_${JSON.stringify(param)}`
    let cached = requestCache.get(key)
    if (cached) {
      return Promise.resolve(cached)
    } else {
      return new Promise((resolve, reject) => {
        instance.get(url, {
          params: combineToken(param)
        }).then(res => {
          requestCache.set(key, res)
          resolve(res)
        }).catch(err => {
          console.log(err)
          reject(err)
        })
      })
    }
  }
  return instance.get(url, {
    params: combineToken(param),
  })
}

export const post = (url, param) => {
  let [pathname, rest] = url.split('?')
  let [query] = (rest || "").split('#')
  let token = localStorage.getItem('token')
  return new Promise((resolve, reject) => {
    instance.post(`${pathname}?xauth_ticket=${token}${query ? '&' : ''}${query}`, param)
      .then(res => {
        resolve(res)
      }).catch(err => {
        console.log(err)
        reject(err);
      })
  })
}





// WEBPACK FOOTER //
// ./src/utils/http.js